import React from 'react';
import CustomContainer from '../../../components/CustomContainer';
import BookingConfirmation from './BookingConfirmation';

const BookingConfirmationPage = () => {
  return (
    <CustomContainer>
      <BookingConfirmation />
    </CustomContainer>
  );
};

export default BookingConfirmationPage;
